<template>
  <div class="wkday mb-4">
    <div class="card border-dark">
      <h5 class="card-header">
        <span>{{ dow }} - {{ formatDateDisplayLocal(date) }}</span>
        <button
          type="button"
          class="btn btn-primary btn-sm"
          style="float:right"
          @click="showModal()"
        >
          Add Class
        </button>
      </h5>
      <div class="card-body">
        <table
          class="table table-sm"
          v-if="schedulesDow.length > 0 && !loading"
        >
          <thead>
            <tr>
              <th scope="col">Time</th>
              <th scope="col">Members</th>
              <th scope="col">Class</th>
              <th scope="col">Coach</th>
              <th scope="col">Room</th>
              <th
                scope="col"
                class="text-right"
              >Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in schedulesDow"
              :key="index"
            >
              <th scope="row">
                {{ getTimeFromDateFormatLocal(item.start_at) }} -
                {{ getTimeFromDateFormatLocal(item.end_at) }}
              </th>
              <td>
                <router-link :to="{ name: 'JoinClass', params: {id:item.id}}">Sign In ({{
                  item.bookings != null ? item.bookings.length : 0
                }}/{{ item.gclass.maxamount }})</router-link>

              </td>
              <td>{{ item.gclass.name }}</td>
              <td>{{ item.coach.nickname }}</td>
              <td>{{ item.room.name }}</td>
              <td class="text-right">
                <!--
                <a
                  href="#"
                  @click.prevent="editClick(item)"
                  class="mr-2"
                >
                  <i class="fas fa-cog editbtt"></i>
                </a> -->
                <a
                  href="#"
                  type="button"
                  class="toggleonbtn"
                  @click.prevent="toggleStatus(item)"
                >
                  <i
                    v-if="item.status == 'ACTIVE'"
                    class="fas fa-toggle-on toggleon"
                  ></i>
                  <i
                    v-else-if="item.status == 'CANCELED'"
                    class="fas fa-toggle-off toggleoff"
                  ></i>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
        <div
          v-else-if="loading"
          class="text-center my-2"
        >
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
        <h5
          v-else
          class="text-center nocls"
        >-- No Class --</h5>
      </div>
    </div>
    <modals-container name="class_add_modal" />
  </div>
</template>
<script>
import Vue from "vue";
import VModal from "vue-js-modal";
Vue.use(VModal, { dynamic: true, dynamicDefaults: { clickToClose: true } });
import {
  getTimeFromDateFormat,
  formatDateDisplay
} from "./../js/utils/date.js";
import ClassesAdd from "./ClassesAdd.vue";
export default {
  props: { schedulesDow: Array, dow: String, loading: Boolean, date: String },
  data() {
    return {
      loadingtoggle: false
    };
  },
  methods: {
    editClick(item) {},
    addClick() {},
    getTimeFromDateFormatLocal(date) {
      return getTimeFromDateFormat(date);
    },
    showModal() {
      //console.log(item);
      var self = this;
      this.$modal.show(
        ClassesAdd,
        {
          //--- Component property
          date: this.date,
          dow: this.dow
          //selfmodal: this.$modal,
        },
        {
          //-- Modal Params
          draggable: false,
          height: "auto",
          scrollable: true,
          adaptive: true
        },
        {
          //-- Modal event listener
          "before-close": event => {
            //console.log(event);
            //console.log("this will be called before the modal closes");
            //this.getPackage();
            self.$emit("class-search");
          },
          "before-open": event => {
            //console.log("this will be called before the modal open");
          },
          closed: event => {}
        },
        {}
      );
    },
    async toggleStatus(item) {
      //if (!confirm("Toggle Status?")) return false;
      var self = this;
      var status = item.status;
      if (status == "ACTIVE") {
        status = "CANCELED";
      } else {
        status = "ACTIVE";
      }
      this.loadingtoggle = true;
      await axios
        .post("/api/schedules/setstatus", {
          id: item.id,
          status: status
        })
        .then(response => {
          //item.status = status;
          self.$emit("class-search");
        })
        .catch(e => {
          console.log(e);
        })
        .finally(() => {
          this.loadingtoggle = false;
        });
    },
    formatDateDisplayLocal(date) {
      return formatDateDisplay(date);
    }
  }
};
</script>
<style scoped>
.nocls {
  color: darkgray;
}
.toggleonbtn {
  background-color: transparent;
  padding: 0;
  border: none;
}
.editbtt {
  font-size: 2em;
  color: #444;
}
.toggleon {
  font-size: 2em;
  color: green;
}
.toggleoff {
  font-size: 2em;
  color: maroon;
}
</style>
